//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'AppSystemBar',

    data(){ return {
        p: [
            'Web',
            'YouTube Catcher',
            'Quality Management',
            'License Manager',
            'WP App Store',
            'WP Search Server',
        ]
    }},

    computed: {
        isLoggedIn(){
            return this.$store.getters['auth/token']
        }
    },

    methods: {
        moveToLogin(){
            this.$router.push({ name: 'login' })
        }
    }

}
